
import React, { Component } from 'react';

class NewHere extends Component {

  render() {
    return (
      <li className="dropdown">
        <a className="dropdown-toggle" href="#" //eslint-disable-line
        >
          New Here? <i className="fa fa-angle-down"></i>
        </a>
        <ul className="dropdown-menu">
          <li><a href="/Connect">Connection Card</a></li>
          <li><a href="/WelcomeToChurch">Welcome To Church</a></li>
          <li><a href="/ChristianityExplored">Christianity Explored</a></li>
          <li><a href="/BecomingAPartner">Becoming A Partner</a></li>
        </ul>
      </li>
    );
  }
}

export default NewHere;
